<template>
	<div>
		<!-- 投注历史 -->
		<el-dialog width="494px" :visible.sync="show" :append-to-body="true" @open="open()" @close="close" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="bet_dialog_box">
				<div class="bet_dialog_top_box">
					<div class="bet_dialog_top">
						<div class="bet_dialog_top_title">
							Bet History
						</div>
						<img @click="clickClose()" class="bet_dialog_top_close_icon"
							src="../../../assets/icons/close_icon2.png" alt="" />
					</div>
					<div class="flex_ac_sb">
						<div class="bet_search_time_box">
							<el-date-picker @change="changeTime" class="bet_search_time" v-model="time" type="daterange"
								range-separator="-" start-placeholder="Start Time" end-placeholder="End Time">
							</el-date-picker>
						</div>

						<div class="bet_dialog_menu">
							<el-select v-model="select" slot="prepend" placeholder="" @change="changeSelect">
								<el-option v-for="item in selectList" :label="item.gameTypeName"
									:value="item.gameTypeId"></el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="bet_dialog_content ">
					<div class="bet_dialog_list" v-if="historyList.length>0">
						<div class="bet_dialog_list_item" v-for="(item,index) in historyList" :key="item.detailId">
							<img v-if="item.gameVo&&item.gameVo.gameImage" :src="item.gameVo.gameImage"
								class="bet_dialog_list_item_avatar" alt="" />
							<div class="bet_dialog_list_item_info">
								<div class="bet_dialog_list_item_name">
									<span v-if="item.gameVo&&item.gameVo.gameName" class="color_fff">
										{{item.gameVo.gameName}}
									</span>
									<span v-if="item.gameVo&&item.gameVo.gameCustomer">
										- {{item.gameVo.gameCustomer}}
									</span>
								</div>
								<div class="bet_dialog_list_item_time">
									{{convertUTCTime(item.createTime)}}
								</div>
							</div>
							<div class="bet_dialog_list_item_right">
								<div class="bet_dialog_list_item_right_title">
									₦{{item.balance?item.balance:0}}
								</div>
								<div class="bet_dialog_list_item_right_tag" :class="{'tap1': item.type == 7, 'tap2': item.type == 6,'tap3': item.type == 77}">
									{{item.type==6?'Lost':item.type==7?'Won':'Cancelled'}}
								</div>
							</div>
						</div>
					</div>
					<div v-else class="bet_dialog_list_bet_no">
						<img class="bet_dialog_list_bet_no_icon" src="../../../assets/icons/bet_no.png" alt="" />
					</div>
				</div>

				<div v-if="historyList.length>0" class="flex_as_c">
					<el-pagination background layout="prev, pager, next" :page-size="params.pageSize"
						:total="historyTotal" @current-change="changePageNum">
					</el-pagination>
				</div>


			</div>
		</el-dialog>

	</div>
</template>

<script>
	import moment from'moment-timezone';
	import { mapState } from 'vuex';


	export default {
		name: 'referralDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				time: null, //时间筛选
				historyList: [], //投注列表
				historyTotal: 0,
				params: {
					gameTypeId: '', //游戏ID
					startTime: '', //2025-03-15
					endTime: '', //
					pageNum: 1, //
					pageSize: 10, //
				},
				select: '', //类别筛选
				selectList: [{
					gameTypeId: '',
					gameTypeName: '',
				}]
			}
		},
		computed: {
			...mapState(['currentCountry']), // 映射 user 模块下的 userInfo 状态
		},
		mounted() {
		},
		methods: {		// 根据不同时区转化时间
			convertUTCTime(utcTimestamp){
				// 获取用户本地时区偏移量（分钟）
				const utcMoment = moment.utc(utcTimestamp);
				const localMoment = utcMoment.tz(this.currentCountry.timezone);
				const formattedTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
				return formattedTime
			},
			open() {
				// 投注记录
				this.getBetHistory()
				// 玩过的游戏列表
				this.getPlayedGames()
			},
			close() {
				this.$emit('close', false)
			},
			clickClose() {
				if (this.rdType == 1) {
					this.close()
				} else if (this.rdType != 1) {
					this.rdType = 1
				}
			},
			resetInfo() {
				this.params.pageNum = 1
				this.historyList = []
				this.getBetHistory()
			},
			// 获取投注历史
			getBetHistory() {
				this.$api.getBetHistory(this.params).then(res => {
					this.historyList = res.rows
					this.historyTotal = res.total
				})
			},
			// 获取玩过的游戏列表
			getPlayedGames() {
				this.$api.getPlayedGames({}).then(res => {
					this.selectList = res.data
					this.selectList.unshift({
						gameTypeId: '',
						gameTypeName: 'All games',
					})
				})
			},
			// 选中筛选游戏
			changeSelect(e) {
				this.params.gameTypeId = e
				this.resetInfo()
			},
			// 选中查询日期
			changeTime(e) {
				this.params.startTime = this.$use.fromDate(e[0])
				this.params.endTime = this.$use.fromDate(e[1])
				this.resetInfo()
			},
			changePageNum(e) {
				this.params.pageNum = e
				this.getBetHistory()
			},

		},
	}
</script>

<style lang="scss">
	.bet_dialog_menu {
		.el-input__inner {
			background: #303643 !important;
			font-size: 14px;
			color: #B0C3E3;
		}
	}

	.el-popper {
		background: #303643 !important;
		color: #B0C3E3 !important;
	}

	.bet_search_time_box {
		.el-range-input {
			background: rgba(0, 0, 0, 0);
			color: #FFFFFF !important;
			font-size: 14px;
		}

		.el-picker-panel__content {
			background: #303643;
		}
	}
</style>
<style scoped lang="scss">
	.bet_dialog_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 494px;
		min-height: 661px;
		max-height: 800px;
		background: #15161C;
		border-radius: 18px;
		max-height: 700px;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding-bottom: 20px;

	}

	.bet_avatar_menu {
		position: relative;
		width: 205px;
		background: #15161C !important;
		border: none !important;
	}

	.bet_avatar_menu_item {
		display: flex;
		align-items: center;
		height: 36px;
		font-size: 16px;
		font-weight: 500;
		color: #A2B4D1 !important;
	}

	.bet_dialog_top_height {}

	.bet_dialog_top_box {
		width: 494px;
		height: 110px;
		background: #161A22;
		border-radius: 18px 18px 0 0;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.bet_dialog_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 70px;
		color: #F0F0F0;
		font-size: 22px;
	}

	.bet_dialog_top_title {
		color: #F0F0F0;
		font-size: 24px;
	}

	.bet_dialog_top_close_icon {
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}


	.bet_dialog_content {
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		padding: 21px 18px 20px;
		text-align: left;
		overflow-y: auto;
	}

	.bet_dialog_day_box {
		width: 97px;
		height: 40px;
		background: #7F8284;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 5px;
		font-weight: bold;
		font-size: 12px;
		color: #161616;
		margin-left: 20px;
		cursor: pointer;

	}

	.bet_dialog_list {
		width: 100%;
	}

	.bet_dialog_list_item {
		width: 100%;
		height: 96px;
		box-sizing: border-box;
		padding: 0 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #1F242F;
		border-radius: 8px;
		margin-bottom: 12px;
	}

	.bet_dialog_list_item_avatar {
		width: 54px;
		height: 54px;
		border-radius: 3px;
	}

	.bet_dialog_list_item_info {
		flex: 1;
		margin-left: 9px;
		color: #fff;
		font-weight: 500;
	}

	.bet_dialog_list_item_name {
		font-weight: 500;
		font-size: 18px;
		color: #91A1BC;
		line-height: 18px;
	}

	.bet_dialog_list_item_time {
		font-weight: 500;
		font-size: 14px;
		color: #7A8BA8;
		line-height: 18px;
		margin-top: 8px;
	}

	.bet_dialog_list_item_right {
		display: flex;
		flex-direction: column;
		align-items: end;
		margin-left: 20px;
	}

	.bet_dialog_list_item_right_title {
		font-weight: 600;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 22px;
	}

	.bet_dialog_list_item_right_tag {
		padding: 4px 10px;
		border-radius: 98px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		font-size: 13px;
		margin-top: 9px;
	}
	.tap1{
		color: #14EB74;
		background-color: rgba(20,235,116,0.2);
	}
	
	.tap2{
		color: #FF5252;
		background-color: rgba(255,82,82,0.2);
	}
	.tap3 {
		color: #646161;
		background-color: rgba(82, 80, 80, 0.2);
	}

	.bet_search_time_box {
		width: 223.51px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.bet_search_time {
		width: 223.51px;
		background: #303643;
		cursor: pointer;
	}

	.bet_dialog_list_bet_no {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 100px;
	}

	.bet_dialog_list_bet_no_icon {
		width: 344px;
		height: 280.09px;
	}
	.flex_as_c {
		padding-top: 18px;
	}
</style>